import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { Link } from 'react-router-dom';
import Fade from 'react-reveal/Fade';

function Contact() {
  return (
    <Box
      sx={{
        backgroundColor: '#111',
        py: { xs: 10, md: 14 },
        borderTop: '1px solid #1e1e1e',
      }}
    >
      <Container maxWidth="md">
        <Fade bottom>
          <Box textAlign="center">
            <Typography
              variant="overline"
              sx={{ color: '#FFA13C', letterSpacing: '0.2em', fontWeight: 600 }}
            >
              Let's Build Together
            </Typography>
            <Typography
              variant="h3"
              sx={{
                color: '#f0f0f0',
                fontWeight: 700,
                mt: 1,
                mb: 2,
                fontSize: { xs: '1.8rem', md: '2.8rem' },
                lineHeight: 1.2,
              }}
            >
              Ready to Start Your Custom Home?
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: '#888',
                maxWidth: 520,
                mx: 'auto',
                mb: 5,
                lineHeight: 1.8,
              }}
            >
              Whether you have a vision in mind or need guidance from the ground up — we're here to make it a reality. Reach out and let's talk.
            </Typography>
            <Button
              component={Link}
              to="/contact"
              variant="contained"
              size="large"
              sx={{
                backgroundColor: '#FFA13C',
                color: '#000',
                fontWeight: 700,
                px: 6,
                py: 1.8,
                borderRadius: 0,
                letterSpacing: '0.1em',
                fontSize: '0.95rem',
                '&:hover': { backgroundColor: '#e8912e' },
              }}
            >
              Get In Touch
            </Button>
          </Box>
        </Fade>
      </Container>
    </Box>
  );
}

export default Contact;
